/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import * as CryptoJS from 'crypto-js';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { EnvVariables } from '../../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../../../providers/session';

@Injectable()
export class Trading_OrderHistoryStore {
  public params: any;
  private paramsKey: string;
  private defaultParams: any;
  private isPersistParams: boolean;
  public isServerPush = false;
  /// *** Data
  private orderHistoryStore: any;
  public activeOrderHistory: any = [];
  constructor(
    // *** System
    private events: Events,
    private storage: Storage,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider) {
  }

  /// *** Configurer les paramètres
  public configParams(defaultParams: any, isPersistParams: boolean) {
    this.paramsKey = '_Trading_OrderHistoryPage.local';
    this.params = defaultParams;
    this.defaultParams = defaultParams;
    this.isPersistParams = isPersistParams;
  }

  /// *** Récupérer les paramètres de la page
  public loadParams() {
    if (this.isPersistParams) {
      return this.storage.get(this.paramsKey).then(
        (data) => {
          if (data) {
            var paramsStr: string = CryptoJS.AES.decrypt(data.toString(), this.globals.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
            this.params = JSON.parse(paramsStr);
          }
          else {
            this.params = deepCopy(this.defaultParams);
            this.persistParams();
          }
        },
        (error) => {
          this.params = deepCopy(this.defaultParams);
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
    else {
      return new Promise<any>((resolve, reject) => { resolve() });
    }
  }

  /// *** Persister les paramètres de la page
  public persistParams() {
    if (this.isPersistParams) {
      var dataCrypt: string = CryptoJS.AES.encrypt(JSON.stringify(this.params), this.globals.CRYPTO_KEY).toString();
      return this.storage.set(this.paramsKey, dataCrypt).then(
        (succeed) => { },
        (error) => {
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
  }

  /// *** Charger le portfeuille du compte
  public load(isRefresh: boolean = false) {
    return new Promise((resolve, reject) => {
      if (isRefresh)
        this.reset();
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let requestParams = new URLSearchParams();
      requestParams.append('ContactID', this.session.data.contactID);
      requestParams.append('StartDate', new Date(this.params.startDate).toISOString());
      requestParams.append('EndDate', new Date(this.params.endDate).toISOString());
      let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
      this.http.get(this.envVariables.tradingOrderHistoryApiEndpoint, options).map(res => res.json()).subscribe(
        (data) => {
          this.orderHistoryStore = deepCopy(data);
          this.activeOrderHistory = deepCopy(data);
          this.sort();
          this._eventsSub();
          resolve();
        },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject();
        });
    });
  }

  // *** Recherche dans la liste des instruments
  public search(ev) {
    this.activeOrderHistory = deepCopy(this.orderHistoryStore);
    if (ev) {
      var filter: string = ev.target.value;
      if (filter && filter.trim() != '') {
        this.activeOrderHistory = this.activeOrderHistory.filter((item) => {
          let title = item.Wording + ' ' + item.No + ' ' + item.AccountTitle;
          let filters = filter.split(' ');
          for (let _filter of filters) {
            if (!(title.toLowerCase().indexOf(_filter.toLowerCase()) > -1))
              return false;
          }
          return true;
        });
      }
    }
    this.sort();
  }

  // *** Trier les instruments
  public sort() {
  }

  // *** Remise à zéro des informations du portefeuille
  public reset() {
    this.activeOrderHistory = [];
    this._eventsUnsub();
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsSub() {
    try {
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsUnsub() {
    try {
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/trading/orderHistory/orderHistory.store.ts